module.exports = {
    "breadcrumbs": `Nar\u{161}ymo kelias`
};


//# sourceMappingURL=lt-LT.main.js.map
